import PropTypes from "prop-types";

// Classes import

/**
 * if you want to use image instead of <svg> uncomment following.
 *
 * import logoDark from 'assets/images/logo-dark.svg';
 * import logo from 'assets/images/logo.svg';
 *
 */

// ==============================|| LOGO SVG ||============================== //
import logo from "assets/images/DV Store Logo.svg";

const LogoMain = ({ reverse, wd }) => {
  return (
    <img
      //   src={theme.palette.mode === "dark" ? logoDark : logo}
      src={logo}
      alt="Mantis"
      width={wd}
    />
    /**
     * if you want to use image instead of svg uncomment following, and comment out <svg> element.
     *
     * <img src={theme.palette.mode === 'dark' ? logoDark : logo} alt="Mantis" width="100" />
     *
     */
    // <>
    //   <svg
    //     id="Layer_2"
    //     data-name="Layer 2"
    //     xmlns="http://www.w3.org/2000/svg"
    //     viewBox="0 0 171.79 147.55"
    //   >
    //     <defs>
    //       <linearGradient
    //         id="linear-gradient"
    //         x1="78.87"
    //         y1="30.45"
    //         x2="131.65"
    //         y2="30.45"
    //         gradientUnits="userSpaceOnUse"
    //       >
    //         <stop offset="0" stopColor="#5a57a1" />
    //         <stop offset=".28" stopColor="#41767c" />
    //         <stop offset=".57" stopColor="#2c905e" />
    //         <stop offset=".82" stopColor="#1fa04c" />
    //         <stop offset="1" stopColor="#1ba646" />
    //       </linearGradient>
    //       <linearGradient
    //         id="linear-gradient-2"
    //         x1="41.1"
    //         y1="62.83"
    //         x2="91.25"
    //         y2="62.83"
    //         gradientUnits="userSpaceOnUse"
    //       >
    //         <stop offset="0" stopColor="#3f3d72" />
    //         <stop offset="1" stopColor="#5263a9" />
    //       </linearGradient>
    //     </defs>
    //     <g id="Layer_1-2" data-name="Layer 1">
    //       <g>
    //         <path
    //           className={classes["cls-2"]}
    //           d="M79.69,99.1c-27.32,0-49.55-22.23-49.55-49.55S52.37,0,79.69,0c6.69,0,13.18,1.31,19.29,3.89l-1.42,3.36c-5.66-2.39-11.67-3.61-17.87-3.61-25.31,0-45.9,20.59-45.9,45.9s20.59,45.9,45.9,45.9,45.9-20.59,45.9-45.9c0-6.24-1.23-12.28-3.65-17.97l3.36-1.43c2.61,6.14,3.94,12.67,3.94,19.4,0,27.32-22.23,49.55-49.55,49.55Z"
    //         />
    //         <path
    //           className={classes["cls-4"]}
    //           d="M78.87,58.68L103.5,6.13s1.44-4.31,6.98-4.31h15.81s7.18-.41,4.93,4.72c-2.26,5.13-21.76,46.39-21.76,46.39,0,0-2.05,6.16-7.8,6.16s-22.78-.41-22.78-.41Z"
    //         />
    //         <path
    //           className={classes["cls-1"]}
    //           d="M90.94,84.7l-21.69-44.29s-1.44-4.31-6.98-4.31c-5.54,0-15.81,0-15.81,0,0,0-7.18-.41-4.93,4.72,2.26,5.13,15.7,31.92,20.89,42.58,1.17,2.39,2.94,6.16,8.69,6.16,3.77,0,11.49-.18,16.99-.3,2.32-.05,3.82-2.47,2.84-4.57Z"
    //         />
    //         <g>
    //           <path
    //             className={classes["cls-3"]}
    //             d="M18.34,130.52v-18.91h11.61l1.37,1.66v15.59l-1.36,1.66h-11.63Zm9.57-15.67h-5.94v12.43h5.94v-12.43Z"
    //           />
    //           <path
    //             className={classes["cls-3"]}
    //             d="M45.68,111.61h3.41l-4.12,18.91h-4.42l-4.44-18.91h3.63l2.84,14.55,3.09-14.55Z"
    //           />
    //           <path
    //             className={classes["cls-3"]}
    //             d="M62.73,122.61v-10.99h12.98v3.24h-9.35v4.67h9.35v10.99h-12.98v-3.24h9.57v-4.67h-9.57Z"
    //           />
    //           <path
    //             className={classes["cls-3"]}
    //             d="M85.41,114.85h-4.91v-3.24h12.98v3.24h-4.44v15.67h-3.63v-15.67Z"
    //           />
    //           <path
    //             className={classes["cls-3"]}
    //             d="M111.26,111.61v18.91h-12.98v-18.91h12.98Zm-3.41,3.24h-5.94v12.43h5.94v-12.43Z"
    //           />
    //           <path
    //             className={classes["cls-3"]}
    //             d="M116.05,130.52v-18.91h12.98v10.99h-4.44l4.44,7.91h-3.41l-4.66-7.91h-1.28v7.91h-3.63Zm3.63-15.67v4.67h5.94v-4.67h-5.94Z"
    //           />
    //           <path
    //             className={classes["cls-3"]}
    //             d="M137.45,114.85v4.67h9.35v3.08h-9.35v4.67h9.35v3.24h-12.98v-18.91h12.98v3.24h-9.35Z"
    //           />
    //         </g>
    //         <g>
    //           <path
    //             className={classes["cls-2"]}
    //             d="M0,147.55v-8.05H4.94l.58,.71v6.64l-.58,.71H0Zm4.08-6.67H1.55v5.29h2.53v-5.29Z"
    //           />
    //           <path
    //             className={classes["cls-2"]}
    //             d="M10.84,147.55h-1.55v-8.05h1.55v8.05Z"
    //           />
    //           <path
    //             className={classes["cls-2"]}
    //             d="M17.07,142.87h3.06v4.68h-5.53v-8.05h5.53v1.38h-3.98v5.29h2.53v-1.99h-1.6v-1.31Z"
    //           />
    //           <path
    //             className={classes["cls-2"]}
    //             d="M25.44,147.55h-1.55v-8.05h1.55v8.05Z"
    //           />
    //           <path
    //             className={classes["cls-2"]}
    //             d="M31.29,140.88h-2.09v-1.38h5.53v1.38h-1.89v6.67h-1.55v-6.67Z"
    //           />
    //           <path
    //             className={classes["cls-2"]}
    //             d="M42.57,144.18h-2.53v3.37h-1.55v-8.05h5.53v8.05h-1.45v-3.37Zm-2.53-3.3v1.99h2.53v-1.99h-2.53Z"
    //           />
    //           <path
    //             className={classes["cls-2"]}
    //             d="M49.33,146.17h3.98v1.38h-5.53v-8.05h1.55v6.67Z"
    //           />
    //           <path
    //             className={classes["cls-2"]}
    //             d="M66.64,139.5h1.45l-1.75,8.05h-1.88l-1.89-8.05h1.55l1.21,6.19,1.32-6.19Z"
    //           />
    //           <path
    //             className={classes["cls-2"]}
    //             d="M73.4,140.88v1.99h3.98v1.31h-3.98v1.99h3.98v1.38h-5.53v-8.05h5.53v1.38h-3.98Z"
    //           />
    //           <path
    //             className={classes["cls-2"]}
    //             d="M82.69,147.55h-1.55v-8.05h1.55l2.53,4.51v-4.51h1.45v8.05h-1.45l-2.53-4.65v4.65Z"
    //           />
    //           <path
    //             className={classes["cls-2"]}
    //             d="M90.43,147.55v-8.05h4.94l.58,.71v6.64l-.58,.71h-4.95Zm4.08-6.67h-2.53v5.29h2.53v-5.29Z"
    //           />
    //           <path
    //             className={classes["cls-2"]}
    //             d="M101.27,147.55h-1.55v-8.05h1.55v8.05Z"
    //           />
    //           <path
    //             className={classes["cls-2"]}
    //             d="M106.58,147.55h-1.55v-8.05h1.55l2.53,4.51v-4.51h1.45v8.05h-1.45l-2.53-4.65v4.65Z"
    //           />
    //           <path
    //             className={classes["cls-2"]}
    //             d="M116.8,142.87h3.06v4.68h-5.53v-8.05h5.53v1.38h-3.98v5.29h2.53v-1.99h-1.6v-1.31Z"
    //           />
    //           <path
    //             className={classes["cls-2"]}
    //             d="M129.1,144.18v-4.68h5.53v1.38h-3.98v1.99h3.98v4.68h-5.53v-1.38h4.08v-1.99h-4.08Z"
    //           />
    //           <path
    //             className={classes["cls-2"]}
    //             d="M140.48,140.88h-2.09v-1.38h5.53v1.38h-1.89v6.67h-1.55v-6.67Z"
    //           />
    //           <path
    //             className={classes["cls-2"]}
    //             d="M153.21,139.5v8.05h-5.53v-8.05h5.53Zm-1.45,1.38h-2.53v5.29h2.53v-5.29Z"
    //           />
    //           <path
    //             className={classes["cls-2"]}
    //             d="M156.97,147.55v-8.05h5.53v4.68h-1.89l1.89,3.37h-1.45l-1.98-3.37h-.54v3.37h-1.55Zm1.55-6.67v1.99h2.53v-1.99h-2.53Z"
    //           />
    //           <path
    //             className={classes["cls-2"]}
    //             d="M167.81,140.88v1.99h3.98v1.31h-3.98v1.99h3.98v1.38h-5.53v-8.05h5.53v1.38h-3.98Z"
    //           />
    //         </g>
    //       </g>
    //     </g>
    //   </svg>
    // </>
  );
};

LogoMain.propTypes = {
  reverse: PropTypes.bool,
};

export default LogoMain;
